import React from 'react';
import clsx from 'clsx';
import { TitleImage } from "../AboutPageGeneralComp";
import DesignPageSection1 from "./DesignPageSection1";
import DesignPageSection2 from "./DesignPageSection2";

/**
 * This component renders all the info inside markdown body about example of 
 * designing a new page. Due to multiple steps to design a new page the steps
 * have been separated to section 1 and sectio 2 
 */
const DesignPageSection = ({myRef, elSubRefs}) => (
    <section ref={myRef} id="Group8" className={clsx("group")}>
        {/* Title section  */}
        <h3 id="Group8">Design your page</h3><br />
        <TitleImage
            title= 'You can now start designing your page.'
            srcImg= '/images/AboutPageMarkdownImg/6.jpg'
        />
        <DesignPageSection1 elSubRefs={elSubRefs} /> { /* First section with steps of design page example */ }
        <DesignPageSection2 elSubRefs={elSubRefs} /> { /* Second section with steps of design page example */ }
    </section>    
)


export default DesignPageSection;